import UserLayout from "../../components/UserLayout";
import ViewAdvertisement from "../../components/user/ViewAdvertisement";

const ViewAdvertisementPage = () => {
    return (
        <UserLayout>
            <ViewAdvertisement />
        </UserLayout>
    );
}

export default ViewAdvertisementPage;